import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
const PRICE_TYPES = [
  { key: 'peak', label: 'Peak Pricing' },
  { key: 'non-peak', label: 'Non-Peak Pricing' },
];
import './price-type-indicator.less';

const PriceTypeIndicator = ({ types, useInlineColors, variant }) => {
  const className = useClassName('price-type-indicator');
  const isDynamic = variant === 'dynamic';

  return (
    <div
      className={className(
        ['container', isDynamic ? 'container-dynamic' : ''].filter(Boolean)
      )}>
      {(types || PRICE_TYPES).map(
        ({ key, label, color, textColor, backgroundColor }) => (
          <div
            key={key}
            className={className('price-type')}
            style={
              isDynamic && backgroundColor ? { backgroundColor } : undefined
            }>
            <div
              className={className(['price-indicator', key])}
              style={
                useInlineColors && color
                  ? { backgroundColor: color }
                  : undefined
              }
            />
            <span
              className={className('type')}
              style={isDynamic && textColor ? { color: textColor } : undefined}>
              {label}
            </span>
          </div>
        )
      )}
    </div>
  );
};

PriceTypeIndicator.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      color: PropTypes.string,
      textColor: PropTypes.string,
      backgroundColor: PropTypes.string,
    })
  ),
  useInlineColors: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'dynamic']),
};

PriceTypeIndicator.defaultProps = {
  useInlineColors: true,
  variant: 'default',
};

export default PriceTypeIndicator;
